// extracted by mini-css-extract-plugin
export default {"link":"moFpvq","root":"VnoCOE","label":"bcUeYf"};